import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7oxj1f2e63: FaireBrandEntity = {
  token: "b_7oxj1f2e63",
  type: "brand",
  name: "Monte’s Fine Foods",
  avatarUrl:
    "https://cdn.faire.com/fastly/0a1cd8f3bed1b5ef650fb44ab0d36991e55da4f82a519e8c370b86401ab48eca.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ace4cacb6727a089efa3f5254aa15bb538449c6183ccdfc216e9ad433b24e765.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/0a1cd8f3bed1b5ef650fb44ab0d36991e55da4f82a519e8c370b86401ab48eca.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ace4cacb6727a089efa3f5254aa15bb538449c6183ccdfc216e9ad433b24e765.jpeg",
  location: "Bronx, NY, USA",
  minimumOrderDollars: 27,
  rating: 5,
  reviewCount: 14,
  isInsider: true,
  description:
    "Our sauce is made with 100+ years of family tradition behind it. \n\nWe are Proudly a 100% Clean Label Product. Our Vine Ripened Fresh Plum Tomatoes are the best American grown tomatoes available - which we find  paramount to most Italian tomatoes available today as the popularity of “San Marzano” & similar Italian tomato varieties has led to mechanized commercial farming and mislabeling. Our tomatoes are grown in California via the rural Italian tradition and are washed and steam peeled. Additional ingredients are sourced locally from the best farms in the Hudson Valley, NY whenever seasonably available.\n\nNo tomato blends, pastes, starches, fillers, artificial additives,  colors, dried herbs or added sugars.\n\nVegan, Gluten Free & Certified Kosher",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:24.878Z",
    importedBy: "entity-db-cli",
  },
};
